const initialState = {
  treatmentMenu: [],
  // records: [],
  subTreatments: [],
  treatmentList: []
}

export const treatment = (state = initialState, action) => {
  switch (action.type) {
    case "LIST_TREATMENT_MENU":
      return { ...state, treatmentMenu: action.data };
    // case "LIST_TREATMENT":
    //   return { ...state, records: action.data };
    case "SET_SUB_TREATMENT":
      return { ...state, subTreatments: action.data };
    case "SET_TREATMENT":
      return { ...state, treatmentList: action.data };
    default:
      return state;
  }
};
